import React, { createContext, useContext, ReactNode } from 'react';
import useFaq from '@root/hooks/useFaq';


const defaultState: allAnyTypes = {
  fetchFaqs: () => {},
  addFaq: () => {},
};

const FaqContext = createContext<allAnyTypes>(defaultState);

interface FaqProviderProps {
  children: ReactNode;
}

export const FaqProvider: React.FC<FaqProviderProps> = ({ children }) => {
  const faq = useFaq();
  return (
    <FaqContext.Provider value={faq}>
      {children}
    </FaqContext.Provider>
  );
};

export const useFaqContext = () => {
  return useContext(FaqContext);
};
